import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Typography,
  TextField,
  Grid,
  makeStyles,
} from "@material-ui/core";
import axios from "../../../services/auth/jwt/config";

import GridContainer from "@jumbo/components/GridContainer";
import { Autocomplete, createFilterOptions } from "@material-ui/lab";
import { useDispatch } from "react-redux";
import NewsRequests from "services/news";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  customInput: {
    width: "80%",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
  },
  inputContainer: {
    "& p": {
      fontSize: "14px",
      marginBottom: "10px",
    },
  },
  formControl: {
    width: "100%",
  },
}));

const filterUserOptions = createFilterOptions({
  stringify: (option) =>
    [option.fullName, option.nationalCode, option.personnelCode]
      .filter(Boolean)
      .join(" "),
});

const AddPurchaseDialog = ({ open, handleClose }) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [prizeInputValue, setPrizeInputValue] = useState("");
  const [prizeOptions, setPrizeOptions] = useState([]);
  const [loadingPrizes, setLoadingPrizes] = useState(true);
  const [selectedPrizeId, setSelectedPrizeId] = useState(null);

  const dispatch = useDispatch();

  const fetchUsers = async (searchString) => {
    try {
      const response = await axios.get(`/user/getallusers`, {
        params: {
          page: 1,
          limit: 99,
          searchString,
        },
      });
      setOptions(response.data.docs || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPrizes = async (searchString) => {
    try {
      const response = await axios.get(`/pointshop/item/getall`, {
        params: { page: 1, limit: 99, searchString },
      });
      setPrizeOptions(response.data.docs || []);
    } catch (error) {
      console.error("Error fetching prizes:", error);
    } finally {
      setLoadingPrizes(false);
    }
  };

  useEffect(() => {
    fetchUsers("");
    fetchPrizes("");
  }, []);

  useEffect(() => {
    if (inputValue) {
      const delayDebounceFn = setTimeout(() => {
        fetchUsers(inputValue);
      }, 300);
      return () => clearTimeout(delayDebounceFn);
    } else {
      fetchUsers("");
    }
  }, [inputValue]);

  useEffect(() => {
    if (prizeInputValue) {
      const delayDebounceFn = setTimeout(() => {
        fetchPrizes(prizeInputValue);
      }, 300);
      return () => clearTimeout(delayDebounceFn);
    } else {
      fetchPrizes("");
    }
  }, [prizeInputValue]);

  const handleAddAndClose = () => {
    const data = {
      userId: selectedUserId,
      itemId: selectedPrizeId,
    };
    dispatch(NewsRequests.createPurchase(data));
    setSelectedUserId(null);
    setInputValue("");
    setSelectedPrizeId(null);
    setPrizeInputValue("");
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-add-user-score"
      aria-describedby="alert-add-user-score"
      fullWidth
      maxWidth={"sm"}
    >
      <DialogContent>
        <DialogContentText id="alert-add-user-score-description">
          اضافه کردن خرید جدید
        </DialogContentText>

        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>انتخاب کاربر</Typography>
            <Autocomplete
              id="userAutocomplete"
              options={options}
              filterOptions={filterUserOptions}
              getOptionLabel={(option) => option.fullName || ""}
              getOptionSelected={(option) => option._id === selectedUserId}
              inputValue={inputValue}
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              onInputChange={(event, value) => setInputValue(value)}
              onChange={(event, value) => {
                setSelectedUserId(value ? value._id : null);
              }}
              noOptionsText="موردی یافت نشد"
              loadingText="در حال بارگذاری..."
              loading={loading}
              renderOption={(props, option) => {
                return (
                  <>
                    {props.fullName} - {props.nationalCode} -{" "}
                    {props.personnelCode}
                  </>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="کاربر"
                  variant="outlined"
                  className="customInput"
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6} className={classes.inputContainer}>
            <Typography>جایزه</Typography>
            <Autocomplete
              id="prizeAutocomplete"
              options={prizeOptions}
              getOptionLabel={(option) => option.name || ""}
              isOptionEqualToValue={(option, value) =>
                option?._id === value?._id
              }
              inputValue={prizeInputValue}
              getOptionSelected={(option) => option._id === selectedPrizeId}
              onInputChange={(event, value) => setPrizeInputValue(value)}
              onChange={(event, value) => {
                setSelectedPrizeId(value ? value?._id : null);
              }}
              noOptionsText="موردی یافت نشد"
              loadingText="در حال بارگذاری..."
              loading={loadingPrizes}
              renderOption={(props, option) => {
                return (
                  <>
                    {props.name} - {props.inventory}
                  </>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="جایزه"
                  variant="outlined"
                  className="customInput"
                />
              )}
            />
          </Grid>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAddAndClose} color="primary">
          اضافه کردن
        </Button>
        <Button onClick={handleClose} color="secondary" autoFocus>
          انصراف
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddPurchaseDialog;
